// extracted by mini-css-extract-plugin
export var leftAlign = "_2q-2";
export var popper = "_2q-0";
export var subtitle = "_2q-1";